export default {
  empty_list: 'Noch keine Kategorien',
  uses_restaurant_open_times: 'Nutze reguläre Restaurant Öffnungszeiten',
  products_creation_disabled:
    'Aufgrund der aktiven Integration mit {{integration}} ist die Erstellung neuer Produkte nicht möglich. Wenn Sie das Menü ändern müssen, nehmen Sie die Änderungen bitte in {{integration}} vor und synchronisieren Sie das Menü.',
  buttons: {
    add_category: 'Kategorie hinzufügen',
  },
  toasts: {
    something_went_wrong: 'Etwas ist schief gelaufen',
  },
};
